<h1>{{"gipCompanyForm" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Title"}}</h1>
<app-formular [formBuilderInput]="modelInput" [formular]="formular" (action)="action($event)"></app-formular>